module.exports = __webpack_public_path__ + "img/mexico.b1d7f4a.webp";